import AnimatedCheckmark from '@components/icons/AnimatedCheckmark/AnimatedCheckmark'
import { selectLabels } from '@redux/globalSlice'
import clsx from 'clsx'
import { PropsWithChildren, Ref, forwardRef } from 'react'
import { useSelector } from 'react-redux'
import Heart from '../Icons/Heart/Heart'
import s from './EcomButtonGroup.module.scss'

export interface Props {
  /**
   * Add to bag label
   * @default ADD TO BAG
   * @description Label for the add to bag button
   */
  addToBagLabel?: string
  /**
   * Find store label
   * @default FIND STORE
   * @description Label for the find store button
   */
  findStoreLabel?: string
  /**
   * Classname
   */
  className?: string

  onClickAddToCart?: () => void
  onClickAddToWishlist?: () => void
  disabled?: boolean
  loadingAddToCart?: boolean
  addedToWishList?: boolean
  setBackInStockModalOpen: (open: boolean) => void
  metadata?: {
    __typename?: 'KeyValuePairOfStringAndString'
    key: string
    value: string
  }[]
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>

export type EcomButtonGroupProps = Props & NativeAttrs

const EcomButtonGroup = forwardRef<
  HTMLDivElement,
  PropsWithChildren<EcomButtonGroupProps>
>(
  (
    {
      addToBagLabel = 'ADD TO BASKET',
      findStoreLabel = 'FIND STORE',
      className,
      onClickAddToCart,
      onClickAddToWishlist,
      disabled,
      loadingAddToCart,
      setBackInStockModalOpen,
      addedToWishList,
      metadata,
    },
    buttonRef: Ref<HTMLDivElement>,
  ) => {
    const labels = useSelector(selectLabels)
    return (
      <div className={clsx(s.root, className)} ref={buttonRef}>
        <button
          className={clsx(s.button, s.primary)}
          name="add-to-cart"
          aria-label="Add to bag"
          type="button"
          // disabled={disabled}
          onClick={
            disabled ? () => setBackInStockModalOpen(true) : onClickAddToCart
          }
          //@ts-ignore
        >
          {loadingAddToCart ? (
            <div className={s.checkmark}>
              <div className={s.checkmarkInner}>
                <AnimatedCheckmark />
              </div>
              &nbsp;
            </div>
          ) : (
            <span className={s.label}>
              {disabled
                ? labels.outOfStock
                  ? labels.outOfStock
                  : // : 'Out of stock'
                    'Notify me when available'
                : addToBagLabel}
            </span>
          )}
        </button>

        <button
          className={clsx(s.wishlistButton, s.button)}
          name="add-to-wishlist"
          aria-label="Add to wishlist"
          onClick={onClickAddToWishlist}
          type="button"
          title={addedToWishList ? 'Remove from wishlist' : 'Add to wishlist'}
        >
          <Heart width={18} height={16} filled={addedToWishList} />
        </button>
      </div>
    )
  },
)
EcomButtonGroup.displayName = 'EcomButtonGroup'
export default EcomButtonGroup
